import React, { useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Input from "@mui/material/Input";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function CustomTextField({
  type,
  value,
  onChange,
  label,
  error,
  id,
  options,
  readOnly,
  requried,
  disabled,
  errorHandle,
  OnBlurEvent,
  autoFocusElement,
  placeHolder,
  errorMsg,
  ...otherProps
}) {
  const { localization } = useLanguageContext();
  const labelStyle = {
    color: "Black",
    fontSize: "14px",
    backgroundColor: "white",
  };
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const inputClass = "custom-input";
  const inputRef = useRef(null);

  const handleChangeMultiple = (event) => {
    onChange(event.target.value);
  };

  const handleChange = (e) => {
    onChange(type === "multiline" ? e.target.value.trim() : e.target.value);
    if (error && e.target.value) {
      errorHandle((prev) => ({ ...prev, [id]: false }));
    }
  };

  useEffect(() => {
    if (autoFocusElement === id) {
      inputRef.current.focus();
    }
  }, [autoFocusElement]);

  const handleNumberInput = (e) => {
    if (e.target.value === "" || parseFloat(e.target.value) > 0) {
      onChange(e.target.value);
    }
    if (error && parseFloat(e.target.value) > 0) {
      errorHandle((prev) => ({ ...prev, [id]: false }));
    }
  };

  if (type === "text") {
    return (
      <TextField
        key={label}
        inputRef={inputRef}
        className="mb-5"
        id={id}
        onBlur={OnBlurEvent}
        readOnly={readOnly}
        required={requried}
        label={label}
        value={value}
        onChange={handleChange}
        error={error}
        disabled={disabled}
        variant="outlined"
        InputProps={{ classes: { input: inputClass } }}
        InputLabelProps={{ style: labelStyle }}
        style={{ width: "100%", fontSize: "14px" }}
        {...otherProps}
        helperText={error && localization.required}
      />
    );
  } else if (type === "number") {
    return (
      <TextField
        key={label}
        type="number"
        inputRef={inputRef}
        className="mb-5"
        id={id}
        onBlur={OnBlurEvent}
        readOnly={readOnly}
        required={requried}
        label={label}
        onInput={handleNumberInput}
        value={value}
        placeholder={placeHolder}
        error={error}
        disabled={disabled}
        variant="outlined"
        InputProps={{ classes: { input: inputClass } }}
        InputLabelProps={{ style: labelStyle }}
        style={{ width: "100%", fontSize: "14px" }}
        {...otherProps}
        helperText={error && localization.required}
      />
    );
  } else if (type === "multiline") {
    return (
      <TextField
        key={label}
        rows={4}
        multiline
        inputRef={inputRef}
        className="mb-5"
        id={id}
        onBlur={OnBlurEvent}
        readOnly={readOnly}
        required={requried}
        label={label}
        value={value}
        onChange={handleChange}
        error={error}
        disabled={disabled}
        variant="outlined"
        InputProps={{ classes: { input: inputClass } }}
        InputLabelProps={{ style: labelStyle }}
        style={{ width: "100%", fontSize: "14px" }}
        {...otherProps}
        helperText={error && errorMsg}
        placeholder={placeHolder}
      />
    );
  } else if (type === "select") {
    return (
      <TextField
        className="mb-5 customTextFieldSelect"
        id={id}
        inputRef={inputRef}
        onBlur={OnBlurEvent}
        select
        SelectProps={{
          native: true,
        }}
        variant="outlined"
        placeholder=""
        disabled={disabled}
        error={error}
        InputLabelProps={{ style: labelStyle }}
        value={value}
        onChange={handleChange}
        label={label}
        InputProps={{ classes: { input: inputClass } }}
        helperText={error && localization.required}
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.value === ""}
          >
            {option.label}
          </option>
        ))}
      </TextField>
    );
  } else if (type === "multiSelect") {
    return (
      <Select
        native
        multiple
        displayEmpty
        value={[]}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <em>Placeholder</em>;
          }

          return selected.join(", ");
        }}
        inputProps={{ "aria-label": "Without label" }}
      >
        <option disabled value="">
          <em>Placeholder</em>
        </option>
        <option disabled value="1">
          <em>Placer</em>
        </option>
      </Select>
    );
  }
}
